const RefundPolicy = ({ event }) => {
  let refundPolicy =
    event.refundPolicy && event.refundPolicy !== ""
      ? event.refundPolicy
      : false;
  refundPolicy =
    refundPolicy === "Custom" ? event.customRefundPolicy : refundPolicy;

  if (!refundPolicy) {
    return null;
  }
  return (
    <div style={{ marginTop: 40 }}>
      <h3 style={{ fontWeight: 600 }}>Refund Policy</h3>
      <p>{refundPolicy}</p>
    </div>
  );
};

export default RefundPolicy;



// WEBPACK FOOTER //
// ./components/RefundPolicy.js